// Func = limiting Scope for this file
var lastScrollTop = 0;

var opened = 0;
var start = $('#DateIn').attr('value');
var end = $('#DateOut').attr('value');

(function(){

	$(document).ready(function () {

		if(window.innerWidth < 768){
			$("#primary-nav a").click(function (event) {
				if($(this).next('.submenu').length > 0){
					event.preventDefault();
				}
			});
		}
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(700);
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(300);
		});

		// Main Nav Active
		$("#primary-nav li a").click(function () {
			$(this).addClass("active");
		}, function () {
			$(this).removeClass("active");
		});
		
		// Background Copy Pages
		if ($(".text-modules").hasClass("dark")){
			$(".text-modules").parent().addClass("dark");
		}
		if ($(".text-modules").hasClass("fade")){
			$(".text-modules").parent().addClass("fade");
		}
		/****************************************** */

		// Add Background for First Shortcode
		$('.processed-content section:first-child').addClass('first_shortcode');

		// Add Fade ::after element
		/*var Sections = $(".processed-content section"); 
		var No_sections = Sections.length; 
		console.log(No_sections);
		if (No_sections > '1'){
			$('.processed-content section:last-of-type').addClass('fade');
		}else{
			$('.processed-content section').addClass('fade');
		}	*/
		/****************************************** */

		// Desplegable menu
		// Open
		$(" #open-menu, #open-menu-button-m ").on("click", function(e){
			e.preventDefault();
			$(this).addClass('open-menu');
			$('.menu-block').addClass('open-menu');
			$('#menu-button div.label').text('Close');
			
		});
		// Close
		$(" #close-menu ").on("click", function(e){
			e.preventDefault();
			$('#open-menu').removeClass('open-menu');
			$('.menu-block').removeClass('open-menu');
			$('#menu-button div.label').text('Menu');
		});

		// Desplegable Calendar booking
		// Open
		$(" #open-booking-btn ").on("click", function(){
			$(this).addClass('open-booking');
			$('#bookingContainer').addClass('open-booking');
		});
		// Close
		$(" #close-booking-btn ").on("click", function(){
			$('#open-booking-btn').removeClass('open-booking');
			$('#bookingContainer').removeClass('open-booking');
		});
		
		// Animation Scroll Down Click
		$(" #scroll-down ").on("click", function(){
			$('html,body').animate({
				scrollTop: $(".intro-content").offset().top - 10
			}, 1000);			
		});
		


		/*****************************************************
		 OBSERVER TO ADD PARALLAX EFFECT
		 /*****************************************************/
		 var scrollParallax = []
		 var scrolled = 0
 
		 // screen height
		 var v_height = window.innerHeight
			 || document.documentElement.clientHeight
			 || document.body.clientHeight;
 
		 function doParallax(elm) {
 
			 let boundes = elm.dataset.parallax.split(",") // get it from html
			 //get distance in positive value
			 let distance = Math.abs(boundes[0] - boundes[1])
			 if (boundes[0] > boundes[1]) {
				 //get distance in negative value (to do the scroll inverse)
				 distance = distance * -1
			 }
			 //Equivalent distance using screen height + element height
			 const unit_scroll = distance / (v_height + elm.offsetHeight)
			 let temp = 0
 
			 let topElement = 0;
			 let element = elm;
 
			 let id_elem = elm.dataset.parallaxid
 
			 do {
				 topElement += element.offsetTop || 0;
				 element = element.offsetParent;
			 } while (element)
 
			 let parallaxFunction = function () {
				 //Obtain the distance between top screen and document top 0
				 scrolled = document.documentElement.scrollTop || window.pageYOffset
				 //Distance of bottom page to top of the element
				 let relative_distance = scrolled + v_height - topElement
				 //transpoling data to move the parallax element relative to the scroll of all the screen
				 temp = (unit_scroll * relative_distance) + parseInt(boundes[0])
				 //console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
				 elm.setAttribute('style', 'transform: translate(0, ' + temp + 'px)')
			 }
 
			 scrollParallax[id_elem] = parallaxFunction
 
			 window.addEventListener('scroll', scrollParallax[id_elem])
 
		 }
 
		 let observers_parallax = document.querySelectorAll(".js-parallax-element")
 
		 if (observers_parallax) {
			 let options_parallax = {
				 root: null, // relative to document viewport
				 rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
				 threshold: 0 // visible amount of item shown in relation to root
			 }
 
			 function handler_parallax(entries, observer) {
				 let entry;
				 entries.forEach(function (entry) {
					 if (entry.isIntersecting) {
						 doParallax(entry.target)
					 } else {
						 let id_elem = entry.target.dataset.parallaxid
						 window.removeEventListener('scroll', scrollParallax[id_elem])
					 }
				 })
			 }
 
			 let observable_parallax = new IntersectionObserver(handler_parallax, options_parallax)
			 let counter = 1
			 observers_parallax.forEach(function (element) {
				 observable_parallax.observe(element)
				 element.dataset.parallaxid = counter
				 counter++
			 })
		 }



		//vanilla js scroll animation

		function animateTo(target){
			var gotoTarget = offset(document.getElementById(target)).top - 20;
			var from     = window.pageYOffset;
			var to       = gotoTarget;
			var duration = 1300;
			var start = new Date().getTime();

			//time interval
			var timer = setInterval(function() {
				var time = new Date().getTime() - start;

				if(from <= to ){
					var y = easeInOutQuart(time, from, to - from, duration)
				} else {

					var y = easeInOutQuart(time, from, -(from - to), duration)
				}
				window.scrollTo(0, y)
				if (time >= duration) clearInterval(timer)

			}, 1000 / 60);

			window.scrollTo(0, from)

		}


		//ease movement
		function easeInOutQuart(t, b, c, d) {
			if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
			return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
		}


		 /********************************************************************************
		  END OF OBSERVER TO ADD PARALLAX EFFECT
		  ***********************************************************************************/

		//Call function with browser is resized.

		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#bookingCalendar').datepicker({
			changeMonth: false,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 1,
			minDate:0,
			beforeShowDay: function (date) {

				$.datepicker._defaults.dateFormat = "m/dd/yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				$('#DateIn').attr('value', start);
				$('#DateOut').attr('value', end);


				$('#dates_visible__input').attr('value', start + ' / ' + end);
			
			},
			onChangeMonthYear: function () {
				
			}
		});

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');
		
	});

	window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 0){
		document.getElementById('header').classList.add('down');
		var logoUrl = site_url + 'assets/images/logo-scroll.png';
		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
	} else {
		document.getElementById('header').classList.remove('down');
		var logoUrl = site_url + 'assets/svg/Drummond-HeroLogo.svg';
		document.getElementsByClassName('header__logo')[0].getElementsByTagName('img')[0].setAttribute('src',logoUrl);
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}